"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentType = exports.CommentResourceType = void 0;
var CommentResourceType;
(function (CommentResourceType) {
    CommentResourceType["APPLICATION"] = "APPLICATION";
    CommentResourceType["APPLICATION_SUGGESTION"] = "APPLICATION_SUGGESTION";
    CommentResourceType["ARRANGEMENT"] = "ARRANGEMENT";
    CommentResourceType["PRECEDENT"] = "PRECEDENT";
    CommentResourceType["CREDIT"] = "CREDIT";
    CommentResourceType["CREDENTIAL"] = "CREDENTIAL";
})(CommentResourceType = exports.CommentResourceType || (exports.CommentResourceType = {}));
var CommentType;
(function (CommentType) {
    CommentType["GENERAL"] = "GENERAL";
    CommentType["FEEDBACK"] = "FEEDBACK";
    CommentType["SLA"] = "SLA";
    CommentType["FRAUD"] = "FRAUD";
})(CommentType = exports.CommentType || (exports.CommentType = {}));
//# sourceMappingURL=CommentCommon.js.map